import React from 'react'
import { TableV2 } from 'stylist'
import SamplesTableBody from './SamplesTableBody'
import SamplesTableHead from './SamplesTableHead'
import HeadersList from './HeadersList'
import Label from './Label'
import CSVLink from './CSVLink'
import { useTabulizeReportData } from './hooks'
import styled from '@emotion/styled'

const FullPageColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  padding-left: 20px;
`

const TableLabel = styled.div`
  display: flex;
  justify-content: space-between;
`

const TableContainerNoVerticalScroll = styled(TableV2.Container)`
  overflow-y: hidden;
`

const SamplesTable = ({ data = [] }) => {
  const { tableColumns, tableData } = useTabulizeReportData(data)
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleHideColumn,
    visibleColumns
  } = TableV2.useTable(
    {
      columns: tableColumns,
      data: tableData
    },
    TableV2.useFlexLayout,
    TableV2.useSortBy
  )

  return (
    <FullPageColumn>
      <HeadersList
        headers={data.length && data[0]}
        toggleHideColumn={toggleHideColumn}
        visibleColumns={visibleColumns}
      />
      <TableLabel>
        <Label>Sample Data -- Showing {rows.length} records</Label>
        <CSVLink
          headers={data.length && data[0]}
          tableData={tableData}
          download="samples.csv"
          title="Download Sample Data"
        >
          Download .csv
        </CSVLink>
      </TableLabel>
      <TableContainerNoVerticalScroll>
        <TableV2 {...getTableProps()}>
          <SamplesTableHead headerGroups={headerGroups} />
          <SamplesTableBody
            rows={rows}
            prepareRow={prepareRow}
            getTableBodyProps={getTableBodyProps}
          />
        </TableV2>
      </TableContainerNoVerticalScroll>
    </FullPageColumn>
  )
}

export default SamplesTable



// WEBPACK FOOTER //
// ./src/routes/admin/SamplesTable.js